import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

export const StyledItemBox = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  borderRadius: "9px",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
}));
